import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useColor = () => {
  const token = localStorage.getItem("@Token");
  const [color, setColor] = useState([]);

  useEffect(() => {
    const getColor = async () => {
      try {
        const response = await api.get("api/programacion/color/", {
          headers: {
            Authorization: "Token " + token,
          },
        });
        setColor(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    getColor();
  }, [token]);

  return { color };
};
